import { Component, Input, OnInit } from '@angular/core'
import { FormControl, FormGroupDirective } from '@angular/forms'
import { FormErrorsService } from '@core/services/form-errors/form-errors.service';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html'
})
export class ErrorComponent implements OnInit {

    @Input() input: FormControl;
    @Input() form: FormGroupDirective = null;

    errorType: string = '';
    errorTypeForm: string = '';

    constructor(public formErrorsService: FormErrorsService) { }

    ngOnInit(): void {
        this.input.valueChanges.subscribe(_ => {
            if (this.input.invalid && (this.input.touched || this.input.dirty)) {
                this.errorType = Object.keys(this.input.errors)[0]
            }
            if (this.form.errors) {
                this.errorTypeForm = Object.keys(this.form.errors)[0]
            }
        });
    }

    getCustomValidationLabel(errorType: string): string {
        return (errorType === '') ? errorType : `FORM_ERRORS.${errorType}`;
    }

}
